// In MailerLiteSignupForm.jsx

import { useState } from 'react';
import styles from './MailerLiteSignupForm.module.css';

const MAILERLITE_ACTION_URL =
  'https://assets.mailerlite.com/jsonp/1638121/forms/158861466530743636/subscribe';
const EMAIL_FIELD_NAME = 'fields[email]';
const HIDDEN_FIELDS = {
  'ml-submit': '1',
  anticsrf: 'true',
};

function MailerLiteSignupForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || status === 'submitting') return;

    setStatus('submitting');
    setErrorMessage('');

    const formData = new URLSearchParams();
    formData.append(EMAIL_FIELD_NAME, email);
    for (const key in HIDDEN_FIELDS) {
      formData.append(key, HIDDEN_FIELDS[key]);
    }

    try {
      await fetch(MAILERLITE_ACTION_URL, {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        mode: 'no-cors',
      });

      setStatus('success');
      setEmail('');
    } catch (error) {
      console.error('MailerLite submit error:', error);
      setErrorMessage('A network error occurred. Please try again.');
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className={styles.successMessage}>
        <i className="fas fa-check-circle"></i> Thanks for joining! We'll be in
        touch soon.
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className={styles.signupForm}>
      <input
        type="email"
        placeholder="Enter your email for beta access"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        disabled={status === 'submitting'}
        aria-label="Email for beta access"
      />
      <button
        type="submit"
        className="action-button primary"
        disabled={status === 'submitting'}
      >
        {status === 'submitting' ? 'Joining...' : 'Request Access'}
      </button>
      {status === 'error' && (
        <p className={styles.errorMessage}>{errorMessage}</p>
      )}
    </form>
  );
}

export default MailerLiteSignupForm;
